import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function StripeSuccess() {
	const [searchParams] = useSearchParams();
	const sessionId = searchParams.get("session_id");
	const { refreshUser } = useAuth();
	const [refreshed, setRefreshed] = useState(false);
	
	useEffect(() => {
		const timer = setTimeout(async () => {
			try {
				await refreshUser();
			} catch {
				// ignore
			} finally {
				setRefreshed(true);
			}
		}, 2500);
		return () => clearTimeout(timer);
	}, [refreshUser]);
	
	return (
		<div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-8
		text-center border border-farm-tan/30 dark:border-gray-700
		transition-colors duration-200">
		<div className="text-6xl mb-4">🎉</div>
		<h2 className="text-2xl font-bold text-farm-green dark:text-green-400
		mb-2">
		Payment Successful!
		</h2>
		<p className="text-gray-600 dark:text-gray-400 mb-2">
		Thank you for your payment. Your credits have been added to your
		Cedar Fork Farm account.
		</p>
		
		{!refreshed ? (
			<div className="flex items-center justify-center gap-2
			text-gray-500 dark:text-gray-400 text-sm my-4">
			<div className="animate-spin h-4 w-4 rounded-full border-2
			border-farm-green border-t-transparent" />
			Updating your balance…
			</div>
		) : (
			<div className="bg-green-50 dark:bg-green-900/30 border
			border-green-200 dark:border-green-700 rounded-xl
			p-3 text-green-800 dark:text-green-300 text-sm my-4">
			✅ Your account balance has been updated.
			</div>
		)}
		
		{sessionId && (
			<p className="text-xs text-gray-400 dark:text-gray-500 mb-4
			font-mono">
			Session: {sessionId}
			</p>
		)}
		
		<div className="flex gap-3 justify-center mt-2">
		<Link
		to="/order"
		className="bg-farm-green text-white px-6 py-2 rounded-xl
		hover:bg-green-700 transition-colors font-semibold"
		>
		Order Eggs
		</Link>
		<Link
		to="/account"
		className="border-2 border-farm-green text-farm-green
		dark:border-green-400 dark:text-green-400
		px-6 py-2 rounded-xl hover:bg-farm-green
		hover:text-white dark:hover:bg-green-700
		transition-colors font-semibold"
		>
		View Account
		</Link>
		</div>
		</div>
	);
}
